// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as VisibilityOnComponent} from './VisibilityOn.svg';

import Icon, { TIconProps } from '../Icon';

export const IconVisibilityOn = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <VisibilityOnComponent/>
  </Icon>
));
